import React from "react";
import { cn } from "@/lib/utils";

type CodeEditorProps = {
  title?: string;
  className?: string;
  children: React.ReactNode;
};

const CodeEditor: React.FC<CodeEditorProps> = ({
  title = "developer.cs",
  className,
  children,
}) => {
  return (
    <div className={cn("code-window w-full", className)}>
      <div className="code-editor-header">
        <div className="code-editor-dot bg-red-500" />
        <div className="code-editor-dot bg-yellow-500" />
        <div className="code-editor-dot bg-green-500" />
        <div className="ml-2 text-xs text-gray-400 font-mono">{title}</div>
      </div>
      <div className="px-2 py-4 font-mono text-sm leading-relaxed text-gray-300 overflow-x-auto">
        {children}
      </div>
    </div>
  );
};

export default CodeEditor;
